<script setup lang="ts">
import { VAlert } from 'vuetify/components';

type PropsType = {
    type?: VAlert['$props']['type'];
    variant?: VAlert['$props']['variant'];
    color?: string;
    title?: string;
    closable?: boolean;
};

withDefaults(defineProps<PropsType>(), {
    type: 'info',
    closable: false,
    variant: 'tonal',
});

defineOptions({ inheritAttrs: false });
</script>

<template>
    <VAlert
        :type="type"
        :color="color"
        :title="title"
        :closable="closable"
        :variant="variant"
        v-bind="$attrs"
    >
        <template
            v-if="$slots.title"
            #title
        >
            <slot name="title" />
        </template>

        <slot />
    </VAlert>
</template>
